import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export interface WorkflowCheckpoint {
  version: number; // version of the workflow
  commit_message: string; // commit message of workflow changes giving by user
  api_workflow_file_id: string; // it will be used to form github split view url
  normal_workflow_file_id: string; // it will be used to form github split view url
  workflow_id: string;
  created_at: string;
  workflow_name: string;
  commit_author: string; // author of the commit
  api_config: {
    inputs: any[]; // received as json key value pair and will be changed to yml
    outputs: any[]; // received as json key value pair and will be changed to yml
    is_manual: boolean; // if advanced config is enabled or not
  };
}

export const getWorkflowCheckpoints = async (
  project_id: any,
  workflow_id: string
): Promise<WorkflowCheckpoint[]> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id || !workflow_id) {
    console.warn('Missing access token, repo_id, or workflow_id');
    return [];
  }

  try {
    const response = await axios.get(
      `${API_URL}/v2/project/${project_id}/${workflow_id}/checkpoint`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching workflow checkpoints:', error);
    return [];
  }
};

export const useGetWorkflowCheckpoints = (repo_id: string, workflow_id: string, config = {}) => {
  const { addNotification } = useNotificationStore();

  return useQuery<WorkflowCheckpoint[], Error>(
    ['workflowCheckpoints', repo_id],
    () => getWorkflowCheckpoints(repo_id, workflow_id),
    {
      onError: (error) => {
        addNotification({
          type: 'error',
          title: 'Failed to fetch workflow history',
          message: error.message,
        });
      },
      ...config,
    }
  );
};
